<template>
  <transition-group
    enter-active-class="ease-in-out duration-500"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in-out duration-500"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="active"
      @click="$emit('close')"
      class="bg-ontick-carbon-900 fixed inset-0 z-40 bg-opacity-50 transition-opacity"
      aria-hidden="true"
      key="1"
    ></div>

    <div
      v-show="active"
      class="fixed inset-y-0 right-0 z-50 flex max-w-full pl-10"
      key="2"
    >
      <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <div v-show="active" class="w-screen max-w-md">
          <div
            class="bg-ontick-carbon-500 flex h-full flex-col overflow-y-scroll bg-opacity-75 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
          >
            <div
              class="bg-ontick-carbon-500 sticky top-0 px-6 py-3 pr-14 shadow-lg"
            >
              <div class="flex items-center justify-start">
                <button
                  @click="$emit('close')"
                  class="py-1 text-gray-400 hover:text-gray-400 focus:outline-none"
                >
                  <span v-html="$icons.arrow_left" />
                </button>
                <p class="mx-3 text-left text-gray-300">Notificações</p>
              </div>
            </div>

            <div>
              <ul class="relative w-full overflow-y-auto pb-12 pt-6">
                <li
                  v-for="(item, index) in notification_stream"
                  :key="index"
                  :class="
                    index % 2 === 0
                      ? 'bg-ontick-steel-500'
                      : 'bg-ontick-steel-700'
                  "
                  class="w-full px-4 py-3"
                >
                  <dd class="flex items-baseline justify-between">
                    <div
                      v-if="item.hasOwnProperty('datetime')"
                      class="flex items-baseline text-xs text-gray-400"
                    >
                      {{ item.datetime | moment("DD/MM/YYYY hh:mm:ss:SSS") }}
                    </div>
                    <div
                      v-if="item.hasOwnProperty('time')"
                      class="flex items-baseline text-xs text-gray-400"
                    >
                      {{ item.time }}
                    </div>
                    <span
                      class="bg-ontick-blue-800 text-ontick-blue-300 inline-flex items-center rounded bg-opacity-25 px-2 py-0.5 text-xs font-medium uppercase"
                    >
                      {{ item.topic }}
                    </span>
                  </dd>
                  <p
                    class="trucante py-1 text-left text-sm font-semibold text-gray-300"
                  >
                    {{ item.title }}
                  </p>
                  <p class="text-left text-xs text-gray-300 md:block">
                    <expandable-text-line class="text">
                      <span v-html="item.message"></span>
                    </expandable-text-line>
                  </p>
                </li>
              </ul>
              <div
                v-show="notification_stream.length == 0"
                class="flex h-full items-center justify-center py-4 text-center"
              >
                <span class="text-gray-300" v-html="$icons.chat"></span>

                <p
                  class="px-2 py-3 text-center text-xs normal-case text-gray-300"
                >
                  Nenhuma notificação
                </p>
              </div>
              <div class="absolute bottom-0 w-full">
                <button
                  @click="notificationsRead()"
                  :disabled="notification_stream.length == 0"
                  v-show="notification_stream.length != 0"
                  class="bg-ontick-blue-900 hover:bg-ontick-blue-800 inline-flex w-full items-center justify-center py-2 text-center text-xs font-bold text-gray-300"
                >
                  <span class="pr-1" v-html="$icons.close"></span>
                  Marcar todas como lidas
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition-group>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
  props: {
    active: { type: Boolean, default: false },
  },

  components: {
    ExpandableTextLine: () => import("vue-expandable-text-line"),
  },

  directives: {
    ClickOutside,
  },
  computed: {
    ...mapState({
      notification_stream: (state) => state.notification.notification_stream,
      accountTypes: (state) => state.accountTypes,
    }),
  },

  methods: {
    ...mapActions({
      getNotificationTransient: "notification/getNotificationTransient",
      postTransientDismiss: "notification/postTransientDismiss",
    }),

    notificationsRead() {
      this.postTransientDismiss().then(() => favicon.badge(0));
    },
  },
};
</script>

<style></style>
